<template>
  <section class="work-uploader">
  </section>
</template>

<script>
export default {
  name: 'WorkUploader',

  created() {
    this.make();
  },

  methods: {
    async make() {
      this.$toast.loading();

      const { code, msg } = await this.$fetch('/api/musicService/musicmall/createOrderMaterial', {
        method: 'post',
        data: {
          // 自己的参数
          orderid: this.$route.query.orderid,
          // 客户端传过来的参数
          dataType: this.$route.query.buy_type === 'local' ? '1' : '0',
          dataid: this.$route.query.dataid
        }
      });

      this.$toast.clear();

      if (code === 1) {
        this.$toast.success('上传成功');
      }
      else {
        this.$toast.fail(msg);
      }

      setTimeout(() => {
        this.$router.replace(`/order/${this.$route.query.orderid}`);
      }, 2000);
    }
  }
};
</script>

<style lang="scss" scoped>
.work-uploader {
  background-color: #f8f8f8;
}
</style>
